import React, {Fragment, useEffect, useRef, useState} from "react";
import {Link, NavLink, useLocation,useParams} from "react-router-dom";
import '../../assets/css/home.css';
import axios from "axios";
import clientconfigwebapp, {
    Agent_by_user_get_appbk,
    check_login_appbk, empty_bk,
    FormatNumberByhkh,
    get_first_last_name_local, modal_select_agent_show_hide, redirectbh_typeb,
    scrollTo_uphk, Token_get_appbk
} from "../../clientconfigwebapp";
import {toast, ToastContainer} from "react-toastify";

import Master_Front from "../../pages/Master_Front";


import { Grid, TextField, Button, Typography, Box, Container } from '@mui/material';
import {Iconbk_Contactus_icon1} from "../../assets/icones/icones";
import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";


const Contact_us = (props) => {
    const location_get_urlbk = useLocation();

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    /*  end profile */


    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");


    useEffect(() => {

        scrollTo_uphk();
        Load_api_page();


    }, [location_get_urlbk]);


    const Load_api_page= () => {

        var config = null;

        if(check_login_appbk()==true){
            config = {
                headers: { Authorization: `Bearer ${Token_get_appbk()}` }
            };
        }


        const data_form = null;

        axios.post(`${clientconfigwebapp.siteurl}api/v1/home-get-data/` ,data_form,config)
            .then((res) => {


                if(String(res.data.data).length > 0) {


                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }



                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }

            }).catch((err) =>{
            /// Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 543534', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });





    }



    const Handler_Sendform_Contactus = () => {



        Setloadinghkfullshow("true");

        let form_data = document.querySelector('#form_data_contact');
        if (form_data != null) {
            let formDatanew = new FormData(form_data);
            formDatanew.append("step", "1");
            let data_serialize = new URLSearchParams(formDatanew).toString();

            axios.post(`${clientconfigwebapp.siteurl}api/v1/send-contactus/`, data_serialize, null)
                .then((res) => {
                    Setloadinghkfullshow("false");
                    if (String(res.data).length > 0) {

                        if (String(res.data.status) === "success") {


                            form_data.reset();
                            toast.success("پیام شما با موفقیت ارسال شد", {
                                position: "top-center",
                                autoClose: 8000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });


                        } else {
                            if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        }
                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                }).catch((err) => {
                Setloadinghkfullshow("false");
                toast.error('خطا اتصال به سرور کد  6786324', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
        }
    }


    return (
        <Fragment>

<style jsx>{`
.h1-contactus{

    font-size: 19px;
    font-weight: bold;
    display: block;
    margin-bottom: 8px;
    font-family: 'iran';
}

.description-contactus{
    font-family: 'iran';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 1.9;
    text-align: justify;
    color: #1F2937;
}


.contact_us_seca_right {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: flex-start;
}
.contact_us_seca_left {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: flex-end;
}

.contact_us_seca_left img {
    width: 68% !important;
}



.contactus_section_b_desc {
    line-height: 2.0;
    font-size: 13px;
    text-align: justify;
    padding-left: 25%;
    color: #072733;
}


.section_b_contactus{
    position: relative;
}

.section_b_contactus:after {
    content: "";
    left: -20%;
    position: absolute;
    background-color: #e0f7fa;
    width: 138%;
    height: 100%;
    z-index: -1;
}

.section_b_contactus:after {
    content: "";
    left: -20%;
    position: absolute;
    background-color: #e0f7fa;
    width: 138%;
    height: 100%;
    z-index: -1;
    top: 0px;
    bottom: 0px;
}


.btn-send-contactusform {
    background-color: #ff9828;
    color: white;
    padding: 11px;
    margin-bottom: 14px;
    min-width: 148px;
    border-radius: 11px;
    font-family: 'iran';
    font-size: 16px;
}

span.list-texta-contactus {
    font-size: 17px;
    font-family: 'iran';
    line-height: 1.6;
    color: #000000;
}

ul.list-icons-socialmedia {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    column-gap: 21px;
    margin-top: 12px;
}

.contact_us_secb_right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}


`}</style>


            <Master_Front wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile}>

                <ToastContainer/>

                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow} />




                        <Grid container spacing={4}>

                            <Grid className={"contact_us_seca_right"} item xs={12} md={6}>

                                    <h1 className={"h1-contactus"}>تماس با بازارانو</h1>
                                    <p className={"description-contactus"}>
                                        برای خرید عمده محصولات با کیفیت, از تأمین تا تحویل مستقیم با تیم بازارانو تماس بگیرید!  با ما در ارتباط باشید تا با دسترسی آسان به فروشندگان عمده در سراسر ایران، بهترین گزینه‌ها را برای خرید عمده خود پیدا کنید. ما اینجا هستیم تا نیازهای شما را برآورده کرده و به شما در ارتباط مستقیم با تامین‌کنندگان کمک کنیم. برای اطلاعات بیشتر و مشاوره رایگان، با ما تماس بگیرید
                                    </p>
                            </Grid>

                            <Grid className={"contact_us_seca_left"}  item xs={12} md={6}>
                                <img src={clientconfigwebapp.webappurl + "images/img-contact-us.png"} alt="Phone"
                                     style={{width: '100%'}}/>
                            </Grid>


                        </Grid>

                        <Grid className={"section_b_contactus"} container spacing={4} my={4} style={{backgroundColor: '#e0f7fa', borderRadius: '8px'}}>



                            <Grid className={"contact_us_secb_right"} item xs={12} md={6}>
                                <Iconbk_Contactus_icon1 />
                                <span style={{"fontFamily":"'iran'","fontWeight":"bold","display":"block","marginBottom":"11px","marginTop":"12px"}}>با ما در تماس باشید</span>

                                <p className={"contactus_section_b_desc"}>
                                    در بازارانو، ما با ایجاد ارتباط مستقیم بین خریداران و تأمین‌کنندگان عمده، فرایند خرید عمده را برای شما آسان‌تر کرده‌ایم. تیم ما متعهد است که نیازهای شما را برآورده کند و به شما کمک کند تا با بهترین کیفیت و قیمت، محصولات عمده  مورد نیاز خود را تأمین کنید. برای کسب اطلاعات بیشتر، مشاوره رایگان و بررسی گزینه‌های مختلف، با ما در ارتباط باشید و تجربه‌ای بی‌نظیر از خرید عمده را احساس کنید!
                                </p>
                            </Grid>


                            <Grid className={"contact_us_secb_left"} item xs={12} md={6}>
                                <form id={"form_data_contact"} name={"form_data_contact"} style={{width: "100%"}}>
                                    <Grid container spacing={2}>


                                        <Grid item xs={12} md={6}>
                                            <div className={"input_box_contact"}>
                                                <label>نام</label>
                                                <input placeholder={"نام خود را وارد نمایید"} className={"inputbk"}
                                                       type={"text"} name={"first_name"}/>
                                            </div>
                                        </Grid>


                                        <Grid item xs={12} md={6}>
                                            <div className={"input_box_contact"}>
                                                <label>نام خانوادگی</label>
                                                <input placeholder={"نام خانوادگی خود را وارد نمایید"}
                                                       className={"inputbk"} type={"text"} name={"last_name"}/>
                                            </div>
                                        </Grid>


                                        <Grid item xs={12} md={6}>
                                            <div className={"input_box_contact"}>
                                                <label>پست الکترونیکی</label>
                                                <input placeholder={"پست الکترونیکی خود را وارد نمایید"}
                                                       className={"inputbk"} type={"email"} name={"email"}/>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <div className={"input_box_contact"}>
                                                <label>عنوان</label>
                                                <input placeholder={"موضوع پیام"} className={"inputbk"} type={"text"}
                                                       name={"title_post"}/>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div className={"input_box_contact"}>
                                                <label placeholder={"پیغام خود را اینجا بنویسید"}>پیام شما</label>
                                                <textarea style={{"height": "159px"}} className={"inputbk"}
                                                          name={"description"} rows={4}></textarea>
                                            </div>
                                        </Grid>

                                        <div style={{
                                            "width": "100%",
                                            "display": "flex",
                                            "justifyContent": "flex-end",
                                            "paddingLeft": "3%"
                                        }}>
                                            <button onClick={Handler_Sendform_Contactus} type={"button"} className={"btn-send-contactusform"}>ارسال</button>
                                        </div>
                                    </Grid>
                                </form>
                            </Grid>
                        </Grid>

                <Grid container spacing={4}>

                    <Grid item xs={12} md={6}>
                    <iframe src="https://balad.ir/embed?p=1Ejd7Jbp97rq5L"
                                        title="آدرس :تهران ،سعادت آباد ، میدان کاج به سمت بلوار اصلی سعادت آباد" width={600} height={350}
                                        frameBorder={0} style={{border: 0}} allowFullScreen aria-hidden="false"
                                        tabIndex={0}/>
                            </Grid>


                            <Grid item xs={12} md={6}>
                                <span style={{
                                    "fontFamily": "'iran'",
                                    "fontWeight": "bold",
                                    "display": "block",
                                    "marginBottom": "16px",
                                    "fontSize": "21px"
                                }}> اطلاعات تماس</span>


                                <ul className="list-icons-detailsprod">
                                    <li>
                                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M17.45 22.75C16.32 22.75 15.13 22.48 13.9 21.96C12.7 21.45 11.49 20.75 10.31 19.9C9.14 19.04 8.01 18.08 6.94 17.03C5.88 15.96 4.92 14.83 4.07 13.67C3.21 12.47 2.52 11.27 2.03 10.11C1.51 8.87 1.25 7.67 1.25 6.54C1.25 5.76 1.39 5.02 1.66 4.33C1.94 3.62 2.39 2.96 3 2.39C3.77 1.63 4.65 1.25 5.59 1.25C5.98 1.25 6.38 1.34 6.72 1.5C7.11 1.68 7.44 1.95 7.68 2.31L10 5.58C10.21 5.87 10.37 6.15 10.48 6.43C10.61 6.73 10.68 7.03 10.68 7.32C10.68 7.7 10.57 8.07 10.36 8.42C10.21 8.69 9.98 8.98 9.69 9.27L9.01 9.98C9.02 10.01 9.03 10.03 9.04 10.05C9.16 10.26 9.4 10.62 9.86 11.16C10.35 11.72 10.81 12.23 11.27 12.7C11.86 13.28 12.35 13.74 12.81 14.12C13.38 14.6 13.75 14.84 13.97 14.95L13.95 15L14.68 14.28C14.99 13.97 15.29 13.74 15.58 13.59C16.13 13.25 16.83 13.19 17.53 13.48C17.79 13.59 18.07 13.74 18.37 13.95L21.69 16.31C22.06 16.56 22.33 16.88 22.49 17.26C22.64 17.64 22.71 17.99 22.71 18.34C22.71 18.82 22.6 19.3 22.39 19.75C22.18 20.2 21.92 20.59 21.59 20.95C21.02 21.58 20.4 22.03 19.68 22.32C18.99 22.6 18.24 22.75 17.45 22.75ZM5.59 2.75C5.04 2.75 4.53 2.99 4.04 3.47C3.58 3.9 3.26 4.37 3.06 4.88C2.85 5.4 2.75 5.95 2.75 6.54C2.75 7.47 2.97 8.48 3.41 9.52C3.86 10.58 4.49 11.68 5.29 12.78C6.09 13.88 7 14.95 8 15.96C9 16.95 10.08 17.87 11.19 18.68C12.27 19.47 13.38 20.11 14.48 20.57C16.19 21.3 17.79 21.47 19.11 20.92C19.62 20.71 20.07 20.39 20.48 19.93C20.71 19.68 20.89 19.41 21.04 19.09C21.16 18.84 21.22 18.58 21.22 18.32C21.22 18.16 21.19 18 21.11 17.82C21.08 17.76 21.02 17.65 20.83 17.52L17.51 15.16C17.31 15.02 17.13 14.92 16.96 14.85C16.74 14.76 16.65 14.67 16.31 14.88C16.11 14.98 15.93 15.13 15.73 15.33L14.97 16.08C14.58 16.46 13.98 16.55 13.52 16.38L13.25 16.26C12.84 16.04 12.36 15.7 11.83 15.25C11.35 14.84 10.83 14.36 10.2 13.74C9.71 13.24 9.22 12.71 8.71 12.12C8.24 11.57 7.9 11.1 7.69 10.71L7.57 10.41C7.51 10.18 7.49 10.05 7.49 9.91C7.49 9.55 7.62 9.23 7.87 8.98L8.62 8.2C8.82 8 8.97 7.81 9.07 7.64C9.15 7.51 9.18 7.4 9.18 7.3C9.18 7.22 9.15 7.1 9.1 6.98C9.03 6.82 8.92 6.64 8.78 6.45L6.46 3.17C6.36 3.03 6.24 2.93 6.09 2.86C5.93 2.79 5.76 2.75 5.59 2.75ZM13.95 15.01L13.79 15.69L14.06 14.99C14.01 14.98 13.97 14.99 13.95 15.01Z"
                                                fill="#374151"/>
                                            <path
                                                d="M18.5 9.75C18.09 9.75 17.75 9.41 17.75 9C17.75 8.64 17.39 7.89 16.79 7.25C16.2 6.62 15.55 6.25 15 6.25C14.59 6.25 14.25 5.91 14.25 5.5C14.25 5.09 14.59 4.75 15 4.75C15.97 4.75 16.99 5.27 17.88 6.22C18.71 7.11 19.25 8.2 19.25 9C19.25 9.41 18.91 9.75 18.5 9.75Z"
                                                fill="#374151"/>
                                            <path
                                                d="M22 9.75C21.59 9.75 21.25 9.41 21.25 9C21.25 5.55 18.45 2.75 15 2.75C14.59 2.75 14.25 2.41 14.25 2C14.25 1.59 14.59 1.25 15 1.25C19.27 1.25 22.75 4.73 22.75 9C22.75 9.41 22.41 9.75 22 9.75Z"
                                                fill="#374151"/>
                                        </svg>
                                        <span className="list-texta-contactus"> 09999792212</span></li>
                                    <li>
                                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M11.9997 22.76C10.5197 22.76 9.02969 22.2 7.86969 21.09C4.91969 18.25 1.65969 13.72 2.88969 8.33C3.99969 3.44 8.26969 1.25 11.9997 1.25C11.9997 1.25 11.9997 1.25 12.0097 1.25C15.7397 1.25 20.0097 3.44 21.1197 8.34C22.3397 13.73 19.0797 18.25 16.1297 21.09C14.9697 22.2 13.4797 22.76 11.9997 22.76ZM11.9997 2.75C9.08969 2.75 5.34969 4.3 4.35969 8.66C3.27969 13.37 6.23969 17.43 8.91969 20C10.6497 21.67 13.3597 21.67 15.0897 20C17.7597 17.43 20.7197 13.37 19.6597 8.66C18.6597 4.3 14.9097 2.75 11.9997 2.75Z"
                                                fill="#374151"/>
                                            <path
                                                d="M10.7514 13.7499C10.5614 13.7499 10.3714 13.6799 10.2214 13.5299L8.72141 12.0299C8.43141 11.7399 8.43141 11.2599 8.72141 10.9699C9.01141 10.6799 9.49141 10.6799 9.78141 10.9699L10.7514 11.9399L14.2214 8.46994C14.5114 8.17994 14.9914 8.17994 15.2814 8.46994C15.5714 8.75994 15.5714 9.23994 15.2814 9.52994L11.2814 13.5299C11.1314 13.6799 10.9414 13.7499 10.7514 13.7499Z"
                                                fill="#374151"/>
                                        </svg>
                                        <span className="list-texta-contactus"> info@bazaarano.com</span></li>
                                    <li>
                                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M17 21.25H7C3.35 21.25 1.25 19.15 1.25 15.5V8.5C1.25 4.85 3.35 2.75 7 2.75H17C20.65 2.75 22.75 4.85 22.75 8.5V15.5C22.75 19.15 20.65 21.25 17 21.25ZM7 4.25C4.14 4.25 2.75 5.64 2.75 8.5V15.5C2.75 18.36 4.14 19.75 7 19.75H17C19.86 19.75 21.25 18.36 21.25 15.5V8.5C21.25 5.64 19.86 4.25 17 4.25H7Z"
                                                fill="#374151"/>
                                            <path
                                                d="M11.9988 12.87C11.1588 12.87 10.3088 12.61 9.6588 12.08L6.5288 9.57997C6.2088 9.31997 6.14881 8.84997 6.4088 8.52997C6.66881 8.20997 7.13881 8.14997 7.45881 8.40997L10.5888 10.91C11.3488 11.52 12.6388 11.52 13.3988 10.91L16.5288 8.40997C16.8488 8.14997 17.3288 8.19997 17.5788 8.52997C17.8388 8.84997 17.7888 9.32997 17.4588 9.57997L14.3288 12.08C13.6888 12.61 12.8388 12.87 11.9988 12.87Z"
                                                fill="#374151"/>
                                        </svg>
                                        <span className="list-texta-contactus">تهران،سعادت آباد،میدان کاج به سمت بلوار اصلی سعادت آباد</span></li>
                                </ul>




                                <ul className="list-icons-socialmedia">
                                    <li>
                                        <a href="https://www.instagram.com/bazaarano.co?igsh=cjhzMnNrdWlydDVj" target={"_blank"} title={"instagram"} rel={"nofollow"}>
                                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                                stroke="#212B36" strokeWidth="1.5" strokeLinecap="round"
                                                strokeLinejoin="round"/>
                                            <path
                                                d="M12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z"
                                                stroke="#212B36" strokeWidth="1.5" strokeLinecap="round"
                                                strokeLinejoin="round"/>
                                            <path d="M17.6361 7H17.6477" stroke="#212B36" strokeWidth={2}
                                                  strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </a>
                                    </li>
                                    <li>
                                        <a href="https://t.me/bazaarano" target={"_blank"} title={"Telegram"}
                                           rel={"nofollow"}>
                                            <svg width={25} height={24} viewBox="0 0 25 24" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M7.64969 6.31991L16.1397 3.48991C19.9497 2.21991 22.0197 4.29991 20.7597 8.10991L17.9297 16.5999C16.0297 22.3099 12.9097 22.3099 11.0097 16.5999L10.1697 14.0799L7.64969 13.2399C1.93969 11.3399 1.93969 8.22991 7.64969 6.31991Z"
                                                    stroke="#212B36" strokeWidth="1.5" strokeLinecap="round"
                                                    strokeLinejoin="round"/>
                                                <path d="M10.3594 13.6501L13.9394 10.0601" stroke="#212B36"
                                                      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://chat.whatsapp.com/GJaHo3zZ3k5AZLnDX3IaEZ"
                                           target={"_blank"} title={"instagram"} rel={"nofollow"}>
                                            <svg width={25} height={24} viewBox="0 0 25 24" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M7.4 20.6C8.9 21.5 10.7 22 12.5 22C18 22 22.5 17.5 22.5 12C22.5 6.5 18 2 12.5 2C7 2 2.5 6.5 2.5 12C2.5 13.8 3 15.5 3.8 17L2.94044 20.306C2.74572 21.0549 3.43892 21.7317 4.18299 21.5191L7.4 20.6Z"
                                                    stroke="#212B36" strokeWidth="1.5" strokeMiterlimit={10}
                                                    strokeLinecap="round" strokeLinejoin="round"/>
                                                <path
                                                    d="M17 14.8485C17 15.0105 16.9639 15.177 16.8873 15.339C16.8107 15.501 16.7116 15.654 16.5809 15.798C16.36 16.041 16.1167 16.2165 15.8418 16.329C15.5714 16.4415 15.2784 16.5 14.9629 16.5C14.5033 16.5 14.012 16.392 13.4937 16.1715C12.9755 15.951 12.4572 15.654 11.9434 15.2805C11.4251 14.9025 10.9339 14.484 10.4652 14.0205C10.001 13.5525 9.58187 13.062 9.20781 12.549C8.83826 12.036 8.54081 11.523 8.32449 11.0145C8.10816 10.5015 8 10.011 8 9.543C8 9.237 8.05408 8.9445 8.16224 8.6745C8.27041 8.4 8.44166 8.148 8.68052 7.923C8.96895 7.6395 9.28443 7.5 9.61793 7.5C9.74412 7.5 9.87031 7.527 9.98297 7.581C10.1002 7.635 10.2038 7.716 10.2849 7.833L11.3305 9.3045C11.4116 9.417 11.4702 9.5205 11.5108 9.6195C11.5513 9.714 11.5739 9.8085 11.5739 9.894C11.5739 10.002 11.5423 10.11 11.4792 10.2135C11.4206 10.317 11.335 10.425 11.2268 10.533L10.8843 10.8885C10.8348 10.938 10.8122 10.9965 10.8122 11.0685C10.8122 11.1045 10.8167 11.136 10.8257 11.172C10.8393 11.208 10.8528 11.235 10.8618 11.262C10.9429 11.4105 11.0826 11.604 11.2809 11.838C11.4837 12.072 11.7 12.3105 11.9344 12.549C12.1778 12.7875 12.4121 13.008 12.651 13.2105C12.8853 13.4085 13.0791 13.5435 13.2323 13.6245C13.2549 13.6335 13.2819 13.647 13.3135 13.6605C13.3495 13.674 13.3856 13.6785 13.4261 13.6785C13.5028 13.6785 13.5613 13.6515 13.6109 13.602L13.9534 13.2645C14.0661 13.152 14.1743 13.0665 14.2779 13.0125C14.3816 12.9495 14.4852 12.918 14.5979 12.918C14.6835 12.918 14.7737 12.936 14.8728 12.9765C14.972 13.017 15.0756 13.0755 15.1883 13.152L16.68 14.2095C16.7972 14.2905 16.8783 14.385 16.9279 14.4975C16.973 14.61 17 14.7225 17 14.8485Z"
                                                    stroke="#212B36" strokeWidth="1.5" strokeMiterlimit={10}/>
                                            </svg>
                                        </a>
                                    </li>
                                    <li>
                                        <svg width={25} height={24} viewBox="0 0 25 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M14.75 9.3V12.2H17.35C17.55 12.2 17.65 12.4 17.65 12.6L17.25 14.5C17.25 14.6 17.05 14.7 16.95 14.7H14.75V22H11.75V14.8H10.05C9.85 14.8 9.75 14.7 9.75 14.5V12.6C9.75 12.4 9.85 12.3 10.05 12.3H11.75V9C11.75 7.3 13.05 6 14.75 6H17.45C17.65 6 17.75 6.1 17.75 6.3V8.7C17.75 8.9 17.65 9 17.45 9H15.05C14.85 9 14.75 9.1 14.75 9.3Z"
                                                stroke="#212B36" strokeWidth="1.5" strokeMiterlimit={10}
                                                strokeLinecap="round"/>
                                            <path
                                                d="M15.75 22H9.75C4.75 22 2.75 20 2.75 15V9C2.75 4 4.75 2 9.75 2H15.75C20.75 2 22.75 4 22.75 9V15C22.75 20 20.75 22 15.75 22Z"
                                                stroke="#212B36" strokeWidth="1.5" strokeLinecap="round"
                                                strokeLinejoin="round"/>
                                        </svg>
                                    </li>
                                </ul>


                            </Grid>

                        </Grid>


            </Master_Front>

        </Fragment>
    );
}

export default Contact_us;